import React, { useEffect, useState } from "react";
import Header from "../../Components/Profile/InvoiceHeader";
import Body from "../../Components/Profile/InvoiceBody";
import axiosConfig from "../../ApiCall/axiosConfig";
import { useLocation } from "react-router-dom";
import { SnackbarProvider, enqueueSnackbar } from "notistack";
import { MainContainer } from "../../Components/SoftwareMain/MainElements";
const customTheme = "red";

const Index = () => {
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(false);
  const [readyCartItems, setReadyCartItems] = useState([]);
  let location = useLocation();
  useEffect(() => {
    setItem(location?.state);
    setLoading(true);
    async function fetchReadyCart() {
      const token = localStorage.getItem("tokenManiarApp");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        },
      };
      try {
        const { data } = await axiosConfig.get("/ready_cart/list", config);
        setReadyCartItems(data.data);
        setLoading(false);
      } catch (error) {
        console.log("Error fetching products:", error);
        showError();
        setLoading(false);
      }
    }
    fetchReadyCart();
  }, [location]);

  const showError = () => {
    enqueueSnackbar("خطا در اتصال به سرور", {
      autoHideDuration: 2000,
      style: { backgroundColor: "#9A2827" },
    });
  };
  const showWarning = (text) => {
    enqueueSnackbar(text, {
      autoHideDuration: 2000,
      style: { backgroundColor: "#DC981B" },
    });
  };
  const updateData = (type) => {
    if (type === "addInvoiceToReadyCart") {
      enqueueSnackbar("فاکتور با موفقیت به سبد آماده اضافه شد.", {
        autoHideDuration: 2000,
        style: { backgroundColor: "#478620" },
      });
    } else {
      async function fetchReadyCart() {
        const token = localStorage.getItem("tokenManiarApp");
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
        };
        try {
          const { data } = await axiosConfig.get("/ready_cart/list", config);
          setReadyCartItems(data.data);

          enqueueSnackbar("فاکتور با موفقیت به سبد آماده جدید اضافه شد.", {
            autoHideDuration: 2000,
            style: { backgroundColor: "#478620" },
          });
        } catch (error) {
          console.log("Error fetching products:", error);
          showError();
        }
      }
      fetchReadyCart();
    }
  };
  return (
    <MainContainer subPage className={customTheme}>
      <SnackbarProvider
        anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
        hideIconVariant={true}
        dense={true}
        maxSnack={1}
        style={{
          fontSize: "14px",
          fontWeight: "900",
          display: "flex",
          justifyContent: "center",
          height: "88px",
          borderRadius: "0",
        }}
      />
      {loading ? (
        <div className="loadingList">
          <div className="spinner"></div>
        </div>
      ) : (
        <>
          <Header
            data={item}
            readyCartData={readyCartItems}
            updateData={updateData}
            showError={showError}
          />
          <Body
            data={item}
            showError={showError}
            showWarning={showWarning}
            updateData={updateData}
            readyCartData={readyCartItems}
          />
        </>
      )}
    </MainContainer>
  );
};

export default Index;
